<template>
  <div class="modal">
    <v-snackbar
      top
      :color="snackbarColor"
      :timeout="3000"
      absolute
      v-model="snackbar"
      >{{ snackbarText }}</v-snackbar
    >

    <div style="width: 500px" class="modal-content">
      <div class="payment">
        <v-btn
          style="right: 10px; top: 10px"
          icon
          color="primary"
          fab
          absolute
          @click="$emit('cancel')"
        >
          <v-icon dark style="font-size: 20px">fa-times</v-icon>
        </v-btn>

        <div class="modal-title">
          <h2 class="point-title">{{ point.address.toString() }}</h2>
          <small class="coor"
            >{{ point.latLng.lat }}, {{ point.latLng.lng }}</small
          >
        </div>

        <div class="errands-container">
          <v-text-field
            :class="{ errorC: validation && !point.contactName }"
            label="Nombre de contacto"
            class="mt-5"
            v-model="point.contactName"
            hide-details
            :maxlength="50"
            type="text"
            @keypress="validString"
            rounded
            filled
          />

          <v-text-field
            hide-details
            rounded
            filled
            :maxlength="15"
            class="mt-5"
            @keypress="isNumber"
            :class="{ errorC: validation && !point.contactPhone }"
            label="Teléfono de contacto"
            v-model.number="point.contactPhone"
          />

          <v-textarea
            rounded
            filled
            rows="3"
            hide-details
            class="mt-5"
            placeholder="Comentarios"
            v-model="point.comments"
          />
        </div>
        <div class="modal-btn">
          <v-btn @click="save" color="primary" height="55" block rounded filled
            >Guardar</v-btn
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "edit-point",
  props: ["point"],
  data() {
    return {
      validation: false,
      snackbar: "",
      snackbarText: "",
      snackbarColor: "red darken-2",
    };
  },
  methods: {
    save() {
      this.validation = true;

      if (!this.point.contactName) {
        this.snackbarText = "Debe ingresar el nombre del contacto.";
        this.snackbar = true;
        return;
      }

      if (!this.point.contactPhone) {
        this.snackbarText = "Debe ingresar el número de teléfono del contacto.";
        this.snackbar = true;
        return;
      }

      this.$emit("success", this.point);
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;

      if (
        (charCode > 31 && (charCode < 48 || charCode > 57)) ||
        charCode == 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    validString(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;

      console.log(charCode);

      if (
        (charCode > 64 && charCode < 91) ||
        (charCode > 96 && charCode < 123) ||
        charCode == 8 ||
        charCode == 32
      )
        return true;
      else {
        // return false;
        evt.preventDefault();
      }
    },
  },
};
</script>


<style lang="scss">
.errands-container {
  color: #000000ad;
  padding: 10px;
}
.close {
  width: 20px;
}

// .fa-times {
//   position: absolute;
//   right: 2%;
//   top: 2%;
//   color: gray;
//   cursor: pointer;
//   padding: 10px;
//   font-size: 20px;
//   width: 30px;
//   height: 30px;
//   display: flex;
//   justify-content: center;
//   align-items: center;
// }
// .fa-times:hover {
//   border-radius: 50%;
//   background-color: rgba(126, 126, 126, 0.144);
//   color: black;
//   font-weight: bold;
// }
.coor {
  color: #FF1744;
}

.text {
  border-radius: 10px;
  border: 0;
  width: 95%;
  padding: 10px;
  margin: 20px 0 20px 0;
  min-height: 30px;
}

// input {
//   appearance: none;
//   border: none;
//   outline: none;
//   display: block;
//   font-size: 14px;
//   color: #111;
//   font-weight: normal;
//   background-color: #eee;
//   padding: 10px 10px;
//   border-radius: 10px;
//   resize: none;
// }

textarea {
  resize: none;
}

// .save {
//   width: 100%;
//   padding: 15px;
//   background-color: #FF1744;
//   border-radius: 15px;
//   appearance: none;
//   border: none;
//   outline: none;
//   font-size: 16px;
//   font-weight: bold;
//   color: white;
//   text-decoration: none;
//   cursor: pointer;
// }

.point-title {
  max-width: 95%;
}

.errorC {
  border: 1px solid red;
}
</style>